module.exports = __webpack_public_path__ + "img/white-check-thin.72e01e5e.svg";